import { UI, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box, Button } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import { ProductFieldProps } from '../../../../constants';

export interface AssetPrincipalCardLoadingProps<T> {
  columns: number;
  rows: number;
  infos: ProductFieldProps<T>[];
  onPress?: () => void;
  forceShowButton?: boolean;
}

export const AssetPrincipalCardLoading = <T,>({
  infos,
  columns,
  rows,
  onPress,
  forceShowButton,
}: AssetPrincipalCardLoadingProps<T>) => {
  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy} p={Spacing['inset.sm']}>
      <VStack space={Spacing['stack.xxxs']}>
        <UI.Text fontSize={Typography['fontsize.lg']} isLoading />
        <Box w="full" h="1px" bgColor={Color['neutral.lightest']} />
        <FlatList
          key="mobile-asset-principal-card-flat-list"
          style={{ overflow: 'visible' }}
          columnWrapperStyle={{
            justifyContent: rows === 1 ? 'space-between' : undefined,
            paddingVertical: Utils.Token.ToInt(Spacing, 'stack.nano'),
          }}
          keyExtractor={(info) => info.key as string}
          data={infos}
          renderItem={({ item: info }) => (
            <VStack
              w={rows !== 1 ? `${100 / columns}%` : undefined}
              space={Spacing['stack.quarck']}>
              <UI.Text fontSize={Typography['fontsize.xs']} color="neutral.black">
                {info.label}
              </UI.Text>
              <UI.Text isLoading />
            </VStack>
          )}
          numColumns={columns}
        />
        {(!!onPress || !!forceShowButton) && (
          <Button
            p={0}
            alignSelf="flex-end"
            disabled
            onPress={onPress}
            variant="textLink"
            _text={{
              textTransform: 'uppercase',
              color: 'brand.tertiary.principal',
              fontFamily: Typography['fontfamily.base.semibold'],
            }}
            rightIcon={
              <UI.Icon name="ArrowRight" color={Color['brand.tertiary.principal']} size="xxs" />
            }>
            mais detalhes
          </Button>
        )}
      </VStack>
    </UI.Shadow>
  );
};
